import { Assets, Flex, Headings, Link, Text } from '@foradevelopment/fora-ui';

import { links } from '../../router/links';
import { useTypedTranslation } from '../../i18n/i18n';

export const ErrorPageNoSelectedOrganization = () => {
  const { t } = useTypedTranslation();
  return (
    <Flex
      flexDirection="column"
      alignItems="center"
      rowGap={40}
      marginRight="auto"
      marginLeft="auto"
      maxWidth={['100%', '100%', 785]}
    >
      <Headings.H2 styleAs="h1">{t('errorMessages.noCompany.title')}</Headings.H2>
      <Assets.BindersIllustration width={[180, 180, 200]} />
      <Text width={['auto', 560, 'auto']} size="large" textAlign="center">
        {t('errorMessages.noCompany.description')}
      </Text>
      <Link to={links.fileDashboard} fontSize="medium">
        {t('common.linkToReportOverview')}
      </Link>
    </Flex>
  );
};
